$(function () {
  if ($('.rellax').length) {
    var rellax = new Rellax(".rellax", { center: !0 });
  }

  if ($('.rellax-horizontal').length) {
    var rellax_horizontal = new Rellax(".rellax-horizontal", { horizontal: !0 });
  }

  $(".js-search-button").click(function () {
    $(this).toggleClass("active"),
      $(this).parent().toggleClass("visible"),
      $(".header").removeClass("headerup");
  }),
    $(".js-sub-menu-title").click(function () {
      $(this).next().addClass("visible"),
        $(".mobile-menu__body").toggleClass("overflow-hidden");
    }),
    $(".js-mobile-sub-menu-close").click(function () {
      $(this).parent().parent().removeClass("visible"),
        $(".mobile-menu__body").toggleClass("overflow-hidden");
    }),
    $(".js-footer-menu-title").click(function () {
      $(this).hasClass("active") ||
        $(".js-footer-menu-title").removeClass("active"),
        $(this).toggleClass("active");
    }),
    $(".dropdown__active-item").click(function () {
      $(this).parent().toggleClass("visible-submenu");
    }),
    $(".js-menu-back").click(function () {
      $(this).closest(".dropdown").toggleClass("visible-submenu");
    }),
    $(".js-submenu-back").click(function () {
      $(this).closest(".submenu__item").toggleClass("visible-submenu");
    }),
    $(".js-mobile-submenu a").on("click", function (e) {
      if (e.target.href === "#" || e.target.href === undefined) {
        e.preventDefault();
      }
    });
  var e = $(window),
    s = e.scrollTop();
  e.scroll(function () {
    s > 30
      ? ($(".header").addClass("fixed"),
        e.scrollTop() < s
          ? ($(".header").removeClass("headerup"),
            $(".top-line").removeClass("headerup"))
          : ($(".header").addClass("headerup"),
            $(".top-line").addClass("headerup")))
      : $(".header").removeClass("fixed"),
      (s = e.scrollTop());
  }),
    $(".js-close-modal,.js-modal-background").click(function () {
      $(this).closest(".custom-modal").addClass("hidden"),
        setTimeout(function () {
          $(".custom-modal").removeClass("visible"),
            $("body").removeClass("overflow-hidden");
        }, 500);
    }),
    localStorage.getItem("top-line-white") ||
      setTimeout(function () {
        $("#top-line-white").addClass("visible");
        var e = $("#top-line-white").outerHeight();
        $("body").css("padding-top", e + "px");
      }, 3e3),
    localStorage.getItem("top-line-green") ||
      setTimeout(function () {
        $("#top-line-green").addClass("visible");
        var e = $("#top-line-white").height();
        $("body").css("padding-top", e + "px");
      }, 2e3),
    $(".js-close-top-line").click(function () {
      $(this).closest(".top-line").removeClass("visible");
      var e = $(this).closest(".top-line").attr("id");
      $("body").css("padding-top", "0px"), localStorage.setItem(e, e);
    }),
    setTimeout(function () {
      $("#rebuy-discount-input").attr("placeholder", "Code..."),
        $(".rebuy-cart__flyout-subtotal-label span").each(function () {
          var e;
          (e = $(this).text().split(" ")).unshift('<span class="first-word">'),
            e.splice(2, 0, "</span>"),
            (e = e.join(" ")),
            $(this).html(e);
        });
    }, 1e3);
});
